import {getCompanySubdomain} from "../../../shared/ApiService";

const storeUrlMode = process.env.REACT_APP_STORE_URL_MODE; // single or subdomain
const storeUrlDevPath = 'store';

export function getStoreUrl(url, providedSubdomain = '') {
    if (storeUrlMode === 'subdomain')
        return url;

    const subdomain = providedSubdomain || getCompanySubdomain();
    const rootPath = `/${storeUrlDevPath}/${subdomain}`;
    if (url === '/')
        return rootPath;

    if (url[0] === '/')
        return rootPath + url;

    return `${rootPath}/${url}`;
}
